import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import withTranslationWrapper from "../../HOC/HocTranslate";
import ChatPanel from "./ChatPanel";
import "./index.scss";

const FleetBot = ({ themecolors, logInUser, translate, ServerSetting }) => {
  const [open, setOpen] = useState(false);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const onToggle = () => setOpen((value) => !value);
    const onOpen = () => setOpen(true);
    window.addEventListener("fleetbot:toggle", onToggle);
    window.addEventListener("fleetbot:open", onOpen);
    return () => {
      window.removeEventListener("fleetbot:toggle", onToggle);
      window.removeEventListener("fleetbot:open", onOpen);
    };
  }, []);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("fleetbot:state", { detail: { open } })
    );
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        close();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, close]);

  const currency =
    logInUser?.attributes?.currencyLabel || translate("fleetBotCurrency");

  const liveContext = {
    vehicles: [],
    devices3: [],
    positions: [],
    deviceRelatedData: {},
    allNotifications: {},
    logInUser,
    ServerSetting,
  };

  return (
    <div
      className="fleetbot-root"
      style={{
        "--fb-accent": themecolors.themeLightColor,
        "--fb-accent-text": themecolors.themeLightInverse,
        "--fb-dark": themecolors.themeDarkColor,
        "--fb-dark-text": themecolors.themeInverse,
        "--fb-text": themecolors.textColor,
        "--fb-bg": themecolors.backgroundColor || "#ffffff",
        "--fb-success": themecolors.success || "#4BB543",
        "--fb-error": themecolors.error || "#ff424c",
        "--fb-green": themecolors.menuActiveBackground || "#6FBD43",
      }}
    >
      <ChatPanel
        open={open}
        onClose={close}
        themecolors={themecolors}
        translate={translate}
        currency={currency}
        liveContext={liveContext}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  themecolors: state.themecolors,
  logInUser: state.logInUsers,
  ServerSetting: state.ServerSetting,
});

export default connect(mapStateToProps)(withTranslationWrapper(FleetBot));
